const USERS_ROLE = [
  {
    "role": "Care Provider",
    "value": "careprovider",
    "type": "Careprovider"
  },
  {
    "role": "Office Manager",
    "value": "Office Manager",
    "type": "Staff"
  },
  {
    "role": "RPM Manager",
    "value": "RPM Manager",
    "type": "Staff"
  },
  {
    "role": "Staff",
    "value": "Staff",
    "type": "Staff"
  },
  // {
  //   "role": "Staff",
  //   "value": "Staff Member",
  //   "type": "Staff"
  // },
  {
    "role": "Patient",
    "value": "patient",
    "type": "Patient"
  },
  {
    "role": "Shared/Family Account",
    "value": "Shared/Family Account",
    "type": "Shared"
  },
  {
    "role": "Shared/Family Account",
    "value": "Shared/Family Account",
    "type": "Staff"
  },
  {
    "role": "Other",
    "value": "Other",
    "type": "Staff"
  }
]

const ROLES = {
  careprovider : 'careprovider',
  patient : 'patient',
  admin : 'admin',
  staff : 'Staff',
  rpmManager : 'RPM Manager',
  officeManager : 'Office Manager',
  support: 'support'
}
  module.exports = {
    USERS_ROLE,
    ROLES
  }